import * as React from "react";
const SvgPhotoCover = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.75 3.25A1.75 1.75 0 0 0 0 5v14c0 .966.784 1.75 1.75 1.75h13A1.75 1.75 0 0 0 16.5 19v-5.988a.8.8 0 0 0 0-.022V5a1.75 1.75 0 0 0-1.75-1.75h-13ZM15 11.599V5a.25.25 0 0 0-.25-.25h-13A.25.25 0 0 0 1.5 5v9l.8-.6a.75.75 0 0 1 .886-.01l3.025 2.16 6.054-5.123a.75.75 0 0 1 .901-.051L15 11.599ZM1.5 15.875V19c0 .138.112.25.25.25h13A.25.25 0 0 0 15 19v-5.599l-2.196-1.464-6.07 5.136a.75.75 0 0 1-.92.037l-3.053-2.18-1.261.945ZM18 4.25a.75.75 0 0 0 0 1.5h.5a.25.25 0 0 1 .25.25v12a.25.25 0 0 1-.25.25H18a.75.75 0 0 0 0 1.5h.5A1.75 1.75 0 0 0 20.25 18V6a1.75 1.75 0 0 0-1.75-1.75H18ZM6.75 7.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM4 9a2.75 2.75 0 1 1 5.5 0A2.75 2.75 0 0 1 4 9Zm17-3a.75.75 0 0 1 .75-.75h.5c.966 0 1.75.784 1.75 1.75v10a1.75 1.75 0 0 1-1.75 1.75h-.5a.75.75 0 0 1 0-1.5h.5a.25.25 0 0 0 .25-.25V7a.25.25 0 0 0-.25-.25h-.5A.75.75 0 0 1 21 6Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgPhotoCover;
